import React from 'react';
import { swipe } from '../../assets/images';

import styles from './styles.module.scss'

const SwipeImage = () => {
    return (
        <img src={swipe} alt="swipe" className={styles.swipe} />
    );
};

export default SwipeImage;